/**************************************************
 * Nombre:       Dialogo_Cargar_Pdf
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {subirImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {useContext} from "react";
import {usuarioContext} from "../../App";
import {actualizarDoc} from "../../Servicios/BD/actualizarDoc";
import Formulario_Carga_Pdf from "../Formularios/Formulario_Carga_Pdf";
import {subirPdfHostingFile} from "../../Servicios/AlmacenamientoHosting/subirPdfHostingFile";

const Dialogo_Cargar_Pdf = ({datos, cerrar, realizado}) => {
    const cData = useContext(usuarioContext)
    const {props, obtenerEntidad, setEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        let usuario = cData.usuario
        console.log(usuario)
        let arr = []
        if (usuario.documentos) {
            arr = usuario.documentos
        }

        iniciarCarga('Subiendo...')

        let resultado = await subirPdfHostingFile(entidad.img)
        let img = resultado.data
        let obj = {
            nombre: entidad.nombre,
            fecha: new Date().getTime(),
            tipo: entidad.tipo,
            recurso: img
        }


        let index = arr.findIndex((e) => e.nombre === obj.nombre)

        if (index > -1) {
            arr[index] = obj
        } else {
            arr.push(obj)
        }

        let dox = await actualizarDoc('cuentas', cData.usuario.id, {documentos: arr})
        if (dox.res) {
            cerrar()
            terminar({aviso: 'Documento subido'})
        } else {
            terminar({aviso: 'Algo, inesperado paso, intentelo nuevamente', variante: 'error'})
        }

    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Carga_Pdf props={props} descripcion={datos.descripcion}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Cargar_Pdf